module.exports = __webpack_public_path__ + "img/colored_circles-5.a3c03aa0.png";